import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
import { sizes } from "../../../constants/spacing";
import { Button } from "../../button";
export var ModalFooterButton = styled(Button)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    flex: 1 0 auto;\n    margin-left: ", "px;\n"])), sizes.small);
//# sourceMappingURL=FooterButton.js.map